<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit()">
    <v-card :loading="loading">
      <v-card-text>
        <v-row>
          <v-col>
            <br />
            <h3><v-icon>payment</v-icon> My Subscription</h3>
            <hr />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="font-weight-bold">
              Subscription :
              <v-chip
                color="success"
                v-if="account.subscriptionStatus !== 'Canceled'"
                x-small
                >{{ account.subscriptionStatus }}</v-chip
              >

              <v-chip color="error" v-else x-small>{{
                account.subscriptionStatus
              }}</v-chip>
            </div>
          </v-col>
          <v-col>
            <v-btn
              color="error"
              v-if="account.subscriptionStatus !== 'Canceled'"
              x-small
              @click="cancelSubscription"
              >Cancel Subscription</v-btn
            >
            <v-btn color="info" v-else x-small @click="startSubscription"
              >Start Subscription</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <br />
            <h3><v-icon>info_outline</v-icon> Company Info</h3>
            <hr />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="font-weight-bold">Company Name</div>
            <v-text-field
              :disabled="!editMode"
              solo
              v-model="form.companyName"
              :error-messages="[].concat(fieldErrors('form.companyName'))"
              :hide-details="
                [].concat(fieldErrors('form.companyName')).length === 0
              "
              @blur="$v.form.companyName.$touch()"
            />
          </v-col>
        </v-row>
        <!-- <v-row>
                      <v-col>
                        <div class="font-weight-bold">First Name</div>
                        <v-text-field
                          v-model="form.firstName"
                          :error-messages="
                            [].concat(fieldErrors('form.firstName'))
                          "
                          :hide-details="
                            [].concat(fieldErrors('form.firstName')).length ===
                            0
                          "
                          :disabled="!editMode"
                          solo
                          @blur="$v.form.firstName.$touch()"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <div class="font-weight-bold">Last Name</div>
                        <v-text-field
                          v-model="form.lastName"
                          :error-messages="
                            [].concat(fieldErrors('form.lastName'))
                          "
                          :hide-details="
                            [].concat(fieldErrors('form.lastName')).length === 0
                          "
                          :disabled="!editMode"
                          solo
                          @blur="$v.form.lastName.$touch()"
                        />
                      </v-col>
                    </v-row> -->

        <v-row>
          <v-col>
            <br />
            <h3><v-icon>portrait</v-icon> Company Contacts</h3>
            <hr />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="font-weight-bold">Email</div>

            <v-text-field
              v-model="form.email"
              solo
              :disabled="!editMode"
              :hide-details="[].concat(fieldErrors('form.email')).length === 0"
              :error-messages="[].concat(fieldErrors('form.email'))"
              @blur="$v.form.email.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="font-weight-bold">Phone Number</div>
            <v-text-field
              v-model="form.phoneNumber"
              :disabled="!editMode"
              solo
              hide-details
              v-mask="`(###) ###-####`"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <br />
            <h3><v-icon>place</v-icon> Company Address</h3>
            <hr />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="font-weight-bold">Address</div>

            <v-text-field
              v-model="form.accountAddress"
              :disabled="!editMode"
              solo
              :hide-details="
                [].concat(fieldErrors('form.accountAddress')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.accountAddress'))"
              @blur="$v.form.accountAddress.$touch()"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.accountAddress2"
              :disabled="!editMode"
              solo
              :hide-details="
                [].concat(fieldErrors('form.accountAddress2')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.accountAddress2'))"
              @blur="$v.form.accountAddress2.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="4" md="4" sm="4" xl="4">
            <div class="font-weight-bold">City</div>
            <v-text-field
              v-model="form.accountCity"
              solo
              :disabled="!editMode"
              :hide-details="
                [].concat(fieldErrors('form.accountCity')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.accountCity'))"
              @blur="$v.form.accountCity.$touch()"
            />
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="4" xl="4">
            <div class="font-weight-bold">State</div>
            <state-select
              v-model="form.accountState"
              solo
              :disabled="!editMode"
              :hide-details="
                [].concat(fieldErrors('form.accountState')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.accountState'))"
              @blur="$v.form.accountState.$touch()"
            />
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="4" xl="4">
            <div class="font-weight-bold">Zipcode</div>
            <v-text-field
              v-model="form.accountZipcode"
              solo
              :disabled="!editMode"
              :hide-details="
                [].concat(fieldErrors('form.accountZipcode')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.accountZipcode'))"
              @blur="$v.form.accountZipcode.$touch()"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-show="!editMode" color="info" @click="editMode = true"
          >Edit</v-btn
        >
        <v-btn v-show="editMode" @click="editMode = false">Cancel</v-btn>
        <v-btn
          v-show="editMode"
          color="info"
          type="submit"
          :disabled="$v.$invalid"
          :loading="loading"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>



<script>
import { mapActions, mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "src/mixins/formatterMixin";
import StateSelect from "components/StateSelect";

const validZip = (value) => /^\d{5}(?:[-\s]\d{4})?$/.test(value);

export default {
  components: {
    StateSelect,
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      firstName: { required },
      lastName: { required },
      phoneNumber: { required },
      companyName: { required },
      email: { required, email },
      accountAddress: { required },
      accountAddress2: {},
      accountState: { required },
      accountCity: { required },
      accountZipcode: {
        required,
        validZip,
      },
    },
  },
  validationMessages: {
    form: {
      companyName: {
        required: "Required",
      },
      email: {
        required: "Required",
        email: "Email invalid",
      },
      accountZipcode: {
        required: "Zipcode Required",
        validZip: "Zipcode invalid",
      },
      firstName: {
        required: "Required",
      },
      lastName: {
        required: "Required",
      },
      phoneNumber: {
        required: "Required",
      },
      accountAddress: { required: "Required" },
      accountAddress2: { required: "Required" },
      accountState: { required: "Required" },
      accountCity: { required: "Required" },
    },
  },
  data() {
    return {
      namespace: "Account",
      page: "Account",
      usage: "usage",
      tab: "",
      valid: false,
      loading: false,
      editMode: false,
      form: {
        companyName: "",
        email: "",
        phoneNumber: "",
        accountAddress: "",
        accountCity: "",
        accountState: "",
        accountZipcode: "",
        subscriptionId: "",
        firstName: "",
        lastName: "",
      },
    };
  },
  computed: {
    ...mapState({
      company: (state) => state.company.single,
      user: (state) => state.user.single,
      account: (state) => state.account.data,
    }),
    headerTitle() {
      return this.optional(this.company, "companyName", "Company");
    },
  },
  watch: {
    company(n) {
      if (n) {
        this.form = {
          ...n,
        };
      }
    },
  },
  async mounted() {
    await this.companyGetAccount();
    this.form = {
      ...this.company,
    };
  },
  methods: {
    ...mapActions({
      companyGetAccount: "company/getAccount",
      companyUpdate: "company/update",
      userUpdate: "user/update",
      userGetById: "user/getById",
      subscriptionCancel: "subscription/cancelSubscription",
      subscriptionStart: "subscription/startSubscription",
      subscriptionGetStatus: "subscription/getStatus",
    }),

    serverSideErrors() {
      return [];
    },

    async startSubscription() {
      if (confirm("Are you sure will start subscription?")) {
        await this.subscriptionStart();
        await this.subscriptionGetStatus();
      }
    },

    async cancelSubscription() {
      if (confirm("Are you sure will cancel subscription?")) {
        await this.subscriptionCancel();
        await this.subscriptionGetStatus();
      }
    },

    async submit() {
      this.loading = true;
      await this.companyUpdate(this.form);
      this.$store.dispatch("snackbar/success", "Update Account successful", {
        root: true,
      });
      this.editMode = false;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.ci {
  padding: 4px 16px;
}
</style>